import React, { ReactElement } from 'react';
import { Route, Switch } from 'react-router-dom';
import {
  NotFound as PureNotFound,
  NotificationsProvider
} from '@shootsta/common-react';

// Sub Apps
import SplashNavigator from './SplashNavigator';

// Containers & Layouts
import { ErrorBoundary } from '../common/containers';

import { mapRoutes } from '../utils';

const NotFound = () => <PureNotFound />;

const routes = mapRoutes([
  {
    component: SplashNavigator,
    path: '/:id',
    unprotected: true,
    isPublic: true,
    exact: true
  }
]);

/**
 * Creates the application route components
 *
 * @return {Element}
 */
export default function createRoutes(): ReactElement {
  return (
    <ErrorBoundary>
      <NotificationsProvider>
        <Switch>
          {routes}
          <Route render={NotFound} />
        </Switch>
      </NotificationsProvider>
    </ErrorBoundary>
  );
}
